import {
    Paper,
    Table,
    TableContainer
} from "@mui/material";
import { ColumnHeader } from "./Column";
import DataTable from "./DataTable";
import { useContext } from "react";
import FormContext from "../../../context/FormContext";
import CNResponseView from "../../claim_button/CNResponseView";

const ClaimTable = ({
    claimRecord, setClaimRecord
}) => {

    const {openCNRecord, setOpenCNRecord, currentCNRecord} = useContext(FormContext)

    return (
        <>
            <Paper
                style={{
                    overflow: "hidden",
                }}
            >
                <TableContainer
                    sx={{ maxHeight: "70vh" }}
                >
                    <Table stickyHeader aria-label="sticky table">

                        <ColumnHeader />
                        <DataTable
                            claimRecord={claimRecord}
                            setClaimRecord={setClaimRecord}
                        />
                    </Table>
                </TableContainer>
            </Paper>
            {openCNRecord && <CNResponseView open={openCNRecord} setOpen={setOpenCNRecord} data={currentCNRecord} />}
        </>

    )
}

export default ClaimTable;